var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotationAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 30.1875V20.125M34 40.25H34.0283M28.05 55.2L32.1867 60.7967C32.8018 61.629 33.1094 62.0451 33.4865 62.1939C33.8168 62.3243 34.1832 62.3243 34.5135 62.1939C34.8906 62.0451 35.1982 61.629 35.8133 60.7967L39.95 55.2C40.7806 54.0763 41.1959 53.5144 41.7024 53.0854C42.3778 52.5135 43.1752 52.1089 44.0314 51.9038C44.6735 51.75 45.3657 51.75 46.75 51.75C50.7105 51.75 52.6908 51.75 54.2528 51.0935C56.3355 50.2181 57.9903 48.539 58.853 46.4256C59.5 44.8406 59.5 42.8312 59.5 38.8125V22.425C59.5 17.5945 59.5 15.1793 58.5736 13.3343C57.7586 11.7114 56.4583 10.392 54.8589 9.56507C53.0407 8.625 50.6604 8.625 45.9 8.625H22.1C17.3396 8.625 14.9593 8.625 13.1411 9.56507C11.5417 10.392 10.2414 11.7114 9.42644 13.3343C8.5 15.1793 8.5 17.5945 8.5 22.425V38.8125C8.5 42.8312 8.5 44.8406 9.14702 46.4256C10.0097 48.539 11.6645 50.2181 13.7472 51.0935C15.3092 51.75 17.2895 51.75 21.25 51.75C22.6343 51.75 23.3265 51.75 23.9686 51.9038C24.8248 52.1089 25.6222 52.5135 26.2976 53.0854C26.8041 53.5144 27.2194 54.0763 28.05 55.2Z",
    stroke: "#F4B249",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationAlert);
export default __webpack_public_path__ + "static/media/annotation-alert.e84166f9e691e7b1c44bca04ba8f9c3a.svg";
export { ForwardRef as ReactComponent };